var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99995 10.8866C6.40661 10.8866 5.11328 9.59328 5.11328 7.99995C5.11328 6.40661 6.40661 5.11328 7.99995 5.11328C9.59328 5.11328 10.8866 6.40661 10.8866 7.99995C10.8866 9.59328 9.59328 10.8866 7.99995 10.8866ZM7.99995 6.11328C6.95995 6.11328 6.11328 6.95995 6.11328 7.99995C6.11328 9.03995 6.95995 9.88661 7.99995 9.88661C9.03995 9.88661 9.88661 9.03995 9.88661 7.99995C9.88661 6.95995 9.03995 6.11328 7.99995 6.11328Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99973 14.013C5.49306 14.013 3.12639 12.5463 1.49973 9.99966C0.79306 8.89966 0.79306 7.10633 1.49973 5.99966C3.13306 3.45299 5.49973 1.98633 7.99973 1.98633C10.4997 1.98633 12.8664 3.45299 14.4931 5.99966C15.1997 7.09966 15.1997 8.893 14.4931 9.99966C12.8664 12.5463 10.4997 14.013 7.99973 14.013ZM7.99973 2.98633C5.84639 2.98633 3.78639 4.27966 2.34639 6.53966C1.84639 7.31966 1.84639 8.67966 2.34639 9.45966C3.78639 11.7197 5.84639 13.013 7.99973 13.013C10.1531 13.013 12.2131 11.7197 13.6531 9.45966C14.1531 8.67966 14.1531 7.31966 13.6531 6.53966C12.2131 4.27966 10.1531 2.98633 7.99973 2.98633Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye02);
export default __webpack_public_path__ + "static/media/eye02.590a6ab0.svg";
export { ForwardRef as ReactComponent };